import Component from './NotificationForm.component';
import { NOTIFICATION_TYPES } from '/b2b/notifications/constants';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    const permissions = Object.values(NOTIFICATION_TYPES).filter(value =>
        fromState.Auth.user.hasPermission(state, {
            toPerform: 'write',
            on: value,
        })
    );

    return {
        loading: fromState.Auth.user.isLoading(state),
        permissions,
    };
};

export default connect(mapStateToProps)(Component);
